<template>
  <div
    id="op-overview"
    class="d-flex flex-column pt-3 pb-3"
  >
    <div
      id="description"
      class="d-flex"
    >
      <div class="d-flex flex-column w-100">
        <h2 class="font-weight-bold text-medium">
          {{ operation.name }}
        </h2>
        <h6>{{ `${addressLineOne} ${addressLineTwo}` }}</h6>
      </div>
    </div>
    <div
      v-if="operation.summary"
      class="d-flex flex-column"
    >
      <div class="d-flex flex-column mt-4">
        <h6 class="font-weight-bold text-nowrap text-medium">
          Operation Notes
        </h6>
        <div class="sep-small mb-3 mt-2" />
        <p>
          {{ operation.summary }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    operation: { type: Object, required: true },
  },
  computed: {
    addressLineOne() {
      const items = [
        this.operation.line_one,
        this.operation.line_two,
        this.operation.city,
      ];
      return `${items.join(' ')},`;
    },
    addressLineTwo() {
      const items = [
        this.operation.state.text,
        this.operation.zip,
        this.operation.country.text,
      ];
      return items.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
  #op-overview {
    #description {
      img {
        margin-right: 3rem;
        @media screen and (max-width: 991px) {
          margin-right: 1rem;
        }
      }
    }
  }
</style>
